import {RatingModel} from "../models/domain/ratingModel";
import {RatingReviewMediaModel} from "../models/domain/ratingReviewMediaModel";
import {useState} from "react";

export interface IRatingModalProps {
    rating: RatingModel;
    medium: RatingReviewMediaModel;
    onHide: () => void;
}

export const useRatingModal = ({rating, medium, onHide}: IRatingModalProps) => {
    const initialState = rating.review?.media.findIndex((ratingReviewMedium) => medium.id === ratingReviewMedium.id);
    const [activeIndex, setActiveIndex] = useState<number | undefined>(initialState);
    return {
        rating,
        medium,
        onHide,
        activeIndex,
        onClick: (index: number) => setActiveIndex(index)
    };
}